import Axios from "axios";

const base_Url = 'https://digital-products.thesaicomputers.com/v1'

const token = localStorage.getItem("LoginToken")

export function logout() {
  if (token) {
    localStorage.removeItem("LoginToken");
  }
}

//login api.....
export async function login(loginForm, otp) {

  const body = {
    Mobile_No: loginForm?.mobile_no,
    Android_ID: "9774d56d682e549c",
    otp: otp
  };

  try {
    const response = await Axios.post(`${base_Url}/verify-otp`, body)
    return response;
  } catch (error) {
    return error.response;
  }

  // return new Promise((res, rej) => {
  //   Axios.post(`${base_Url}/verify-otp`, body)
  //     .then((response) => {
  //       res(response);
  //     })
  //     .catch((error) => {
  //       console.log("errror", error);
  //       return res(error);
  //     });
  // });
}